export function parseCollectionIds(raw) {
    return raw
        .split(/[\n,]+/)
        .map((s) => s.trim())
        .filter(Boolean);
}
export function parseCsvCollectionIds(csvText) {
    const lines = csvText
        .split('\n')
        .map((l) => l.trim())
        .filter(Boolean);
    if (lines.length === 0)
        return [];
    const header = lines[0]
        .replace(/^\uFEFF/, '')
        .split(',')
        .map((h) => h.trim().toLowerCase());
    const colIdx = header.indexOf('collectionid');
    if (colIdx === -1) {
        return lines
            .slice(1)
            .map((l) => l.split(',')[0].trim())
            .filter(Boolean);
    }
    return lines
        .slice(1)
        .map((line) => (line.split(',')[colIdx] ?? '').trim())
        .filter(Boolean);
}
